export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SECOND = 10;
export const RES_PER_PAGE = 10;
export const KEY = "42725423-10df-4025-b60b-31517d48ca4e";
export const MODAL_CLOSE_SECOND = 2.5;
